(ns io.daskul.tutorial.webapp.domain.feature-flags.events
  "Feature flags events - fetch and manage feature flags."
  (:require
   [ajax.core]
   [re-frame.core :as rf]
   [io.daskul.tutorial.webapp.shared.api.client :as api]))

;; ============================================================================
;; Fetch My Flags
;; ============================================================================

(rf/reg-event-fx
 ::fetch
 (fn [{:keys [db]} _]
   {:db (assoc-in db [:feature-flags :loading?] true)
    :http-xhrio {:method :get
                 :uri (str api/api-url "/feature-flags/me")
                 :headers (api/auth-header)
                 :response-format (ajax.core/json-response-format {:keywords? true})
                 :on-success [::fetch-success]
                 :on-failure [::fetch-failure]}}))

(rf/reg-event-db
 ::fetch-success
 (fn [db [_ response]]
   (let [flags-by-name (reduce (fn [acc flag]
                                 (assoc acc (:name flag) flag))
                               {}
                               response)]
     (-> db
         (assoc-in [:feature-flags :flags] flags-by-name)
         (assoc-in [:feature-flags :loading?] false)
         (assoc-in [:feature-flags :error] nil)))))

(rf/reg-event-db
 ::fetch-failure
 (fn [db [_ {:keys [response]}]]
   (-> db
       (assoc-in [:feature-flags :loading?] false)
       (assoc-in [:feature-flags :error] (or (:message response) "Failed to fetch feature flags")))))
